import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface CartItem {
  id: number;
  name: string;
  price: number;
  image: string | null;
  qty: number;
}

const CART_KEY = 'sale4all_cart';

@Injectable({ providedIn: 'root' })
export class CartService {
  private _items$ = new BehaviorSubject<CartItem[]>(this.load());

  get items$() { return this._items$.asObservable(); }
  get items(): CartItem[] { return this._items$.value; }
  get count(): number { return this.items.reduce((s, i) => s + i.qty, 0); }
  get total(): number { return this.items.reduce((s, i) => s + i.price * i.qty, 0); }

  add(item: Omit<CartItem, 'qty'>, qty = 1): void {
    const list = [...this.items];
    const idx  = list.findIndex(i => i.id === item.id);
    if (idx > -1) {
      list[idx] = { ...list[idx], qty: list[idx].qty + qty };
    } else {
      list.push({ ...item, qty });
    }
    this.save(list);
  }

  remove(id: number): void {
    this.save(this.items.filter(i => i.id !== id));
  }

  setQty(id: number, qty: number): void {
    if (qty <= 0) { this.remove(id); return; }
    this.save(this.items.map(i => i.id === id ? { ...i, qty } : i));
  }

  clear(): void { this.save([]); }

  private load(): CartItem[] {
    try { return JSON.parse(localStorage.getItem(CART_KEY) || '[]'); } catch { return []; }
  }

  private save(items: CartItem[]): void {
    localStorage.setItem(CART_KEY, JSON.stringify(items));
    this._items$.next(items);
  }
}
